export const actions = {
  requestWords: (offset = 0, search = "", themes = "") => ({
    type: "REQUEST_WORDS_INFO",
    offset,
    search,
    themes,
  }),
  createWord: (payload) => ({
    type: "CREATE_WORD_INFO",
    payload,
  }),
  updateWord: (id, payload) => ({
    type: "UPDATE_WORD_INFO",
    id,
    payload,
  }),
  deleteWord: (id) => ({
    type: "DELETE_WORD_INFO",
    id,
  }),
};
